/* Always-visible scroll indicator for [data-vscroll] lists. The track ([data-vtrack]) sits in its own gutter next to the list, so it never covers content. */
(function () {
  if (window.__dosVScroll) return; window.__dosVScroll = true;
  function trackOf(el) { var t = el.nextElementSibling; return t && t.hasAttribute('data-vtrack') ? t : null; }
  function sync(el) {
    var track = trackOf(el); if (!track) return;
    var thumb = track.firstElementChild; if (!thumb) return;
    var ch = el.clientHeight, sh = el.scrollHeight, over = sh > ch + 2;
    var vis = over ? 'visible' : 'hidden'; if (track.style.visibility !== vis) track.style.visibility = vis;
    if (!over) return;
    var th = track.clientHeight, h = Math.max(32, Math.round(th * ch / sh)), top = Math.round((th - h) * (el.scrollTop / Math.max(1, sh - ch)));
    thumb.style.height = h + 'px'; thumb.style.transform = 'translate3d(0,' + top + 'px,0)';
  }
  var raf = 0;
  function all() { raf = 0; var els = document.querySelectorAll('[data-vscroll]'); for (var i = 0; i < els.length; i++) sync(els[i]); }
  function queue() { if (!raf) raf = requestAnimationFrame(all); }
  document.addEventListener('scroll', function (e) { var el = e.target; if (el && el.hasAttribute && el.hasAttribute('data-vscroll')) sync(el); }, true);
  window.addEventListener('resize', queue);
  function start() { new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] }); queue(); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  /* drag the thumb, or tap the track to jump */
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    var track = e.target.closest && e.target.closest('[data-vtrack]'); if (!track) return;
    var el = track.previousElementSibling; if (!el || !el.hasAttribute('data-vscroll')) return;
    e.preventDefault();
    var thumb = track.firstElementChild, tr = track.getBoundingClientRect(), hr = thumb.getBoundingClientRect();
    var range = Math.max(1, tr.height - hr.height), max = el.scrollHeight - el.clientHeight;
    if (e.target !== thumb) el.scrollTop = ((e.clientY - tr.top - hr.height / 2) / range) * max;
    drag = { el: el, y: e.clientY, st: el.scrollTop, k: max / range };
  });
  window.addEventListener('pointermove', function (e) { if (drag) drag.el.scrollTop = drag.st + (e.clientY - drag.y) * drag.k; });
  window.addEventListener('pointerup', function () { drag = null; });
})();
